module.exports = __webpack_public_path__ + "static/media/star.14d2045a.wav";